import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Cliente} from "./cliente";
import {ClienteService} from "../Services/clientes.service";

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.css']
})
export class ClienteComponent implements OnInit {

  msgs: Message[] = [];
  formCliente : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  ClientesRegistrados:Cliente[];
  ClienteSeleccionado:Cliente;
  tipoGuardado = '';


  constructor(private servicioCliente:ClienteService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesCliente();
    this.Cancelar();
    this.listarClientes();
  }

  crearControlesCliente(){
    this.formCliente = this.fb.group({
      nit:['',Validators.required],
      nombre:['',Validators.required],
      direccion:[''],
      telefono:['',Validators.required],
      email:[''],

      }
    );

  }
  nuevoCliente(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formCliente.enable();
    this.formCliente.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formCliente.reset();
    this.formCliente.disable();
    this.panelRequeridos = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoCliente(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioCliente.putCliente(this.formCliente.value,this.ClienteSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarClientes();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioCliente.addCliente(this.formCliente.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarClientes();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarClientes(){
    this.loading = true;
    this.servicioCliente.getCliente()
      .subscribe(
        rt => {
          this.ClientesRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarCliente(item:Cliente){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formCliente.enable();
    this.panelRequeridos = true;
    this.ClienteSeleccionado = item;
    this.ClienteDetalle(item);
    this.tipoGuardado = 'editar';
  }
  ClienteDetalle(item:Cliente):void {
    this.formCliente.patchValue({
      id:item.id,
      nit:item.nit,
      nombre:item.nombre,
      direccion:item.direccion,
      telefono:item.telefono,
      email:item.email
    });
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/cliente/cliente.component.ts